import { MaterialListItem } from './MaterialListItem'

export class MaterialTreeItem extends MaterialListItem {

    constructor(source: MaterialListItem, expanded: boolean) {
        super(source)
        this.expanded = expanded
    }

    expanded: boolean
}
